<template>
  <el-pagination
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :page-size="pageSize"
    :current-page="page"
    @size-change="onSizeChange"
    @current-change="onPageChange"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  emits: ['size-change', 'current-change'],
  setup(props, { emit }) {
    const onSizeChange = (size: number) => {
      emit('size-change', size);
    };
    const onPageChange = (page: number) => {
      emit('current-change', page);
    };
    return {
      onSizeChange,
      onPageChange,
    };
  },
});
</script>
